import Footer from "components/footer";
import GetStarted from "components/getStarted";
import Navbar from "components/navbar/landingPage-navabar";
import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "./components/header";
import Posts from "./components/blog-posts";

const Blog = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <Container>
      <Navbar />
      <Header />
      <Posts />
      <GetStarted />
      <Footer />
    </Container>
  );
};

export default Blog;

const Container = styled.main``;
